import { Outlet } from 'react-router-dom'

const WhistleBlowings = () => {
  return <Outlet />
}

export default WhistleBlowings
